module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_zh-hant_PC-c72a1967109a6d512db558248cff600c.jpg";